import AssetService from '../services/assets/AssetService';

const _assetService = AssetService.build();

/**
   * This function resolves assets and replace the urn in config with url
   * @param {array} assets
   * @param {string} config
   * @param {number} isV2AssetSchema
   */
export function urnToURL(assets, config, isV2AssetSchema) {
  const updatedConfig = assets.reduce((doc, asset) => {
    if (isV2AssetSchema) return doc;

    return doc.replace(
      new RegExp(asset.urn, 'g'),
      asset.source.original?.url || asset.source.url
    );
  }, config);
  return updatedConfig;
}

export function returnUrnToUrl(asset, assetData, isV2AssetSchema) {
  let originalURL;
  if (isV2AssetSchema) {
    // We are adding 'asset', & 'source.original.url' props in the config to match the internal config
    // This allows Developers to access all assets on /source/url regardless of origin.
    const originalAsset = {
      asset: assetData.asset,
      source: assetData.source,
      urn: asset.urn,
    };
    if (!assetData.source.original && assetData.source.url) {
      const { url } = assetData.source;
      originalAsset.source.original = { url };
      delete originalAsset.source.url;
    }
    originalURL = [JSON.stringify(asset.urn), JSON.stringify(originalAsset)];
  } else {
    originalURL = {
      urn: asset.urn,
      url: assetData.url || assetData?.source?.url || assetData?.source?.original.url,
    };
  }
  return originalURL;
}

export function mapExternalAssets(updatedAssets, config, isV2AssetSchema) {
  let updatedConfig;
  if (isV2AssetSchema) {
    updatedConfig = updatedAssets.reduce((doc,
      [original, replacement]) => doc.replace(new RegExp(original, 'g'), replacement), config);
  } else {
    updatedConfig = updatedAssets.reduce((doc, assetDetails) => (
      doc.replace(new RegExp(assetDetails.urn, 'g'), assetDetails.url)
    ), config);
  }

  return JSON.parse(updatedConfig);
}
/**
   * This function resolves external assets and replace the urn in config with url
   * @param {array} assets
   * @param {string} config
   */
export async function mapExternalUrnToURL(assets, config, isV2AssetSchema) {
  const updatedAssets = await Promise.all(assets.map(async (asset) => {
    // This logic here is to check if we need to grab the asset from BE or not (via asset service)
    // When source original or source url already exist, it means the asset is already avaiable
    // and we dont need to fetch it again.
    if (asset?.source?.original || asset?.source?.url) {
      return returnUrnToUrl(asset, asset, isV2AssetSchema);
    }
    const assetData = await _assetService.resolveAsset(asset.urn);
    return returnUrnToUrl(asset, assetData, isV2AssetSchema);
  }));

  return mapExternalAssets(updatedAssets, config, isV2AssetSchema);
}

/**
   * This function resolves and sets Activity header logo urn to url in config
   * @param {string} config
  */
export async function mapActivityHeaderUrnToURL(config) {
  const _config = JSON.parse(config);
  const assetData = await _assetService.resolveAsset(_config.header.logo);
  _config.header.logo = assetData.original?.url || assetData.url;
  return _config;
}
